"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.householdLongDistanceIntroMap = void 0;
const turf_1 = require("@turf/turf");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
exports.householdLongDistanceIntroMap = {
    type: 'infoMap',
    defaultCenter: project_config_1.default.mapDefaultCenter,
    title: {
        fr: null,
        en: null
    },
    linestringColor: '#0000ff',
    geojsons: function (interview, _path) {
        const startPointGeojsonFeatures = [];
        const startPointGeography = (0, helpers_1.getResponse)(interview, 'home.geography');
        const startPolygonsGeojsonFeatures = [];
        if (startPointGeography) {
            const startPointGeojson = startPointGeography;
            // startPointGeojson.properties.icon = {
            //   url: `/dist/images/activities_icons/default_marker.svg`,
            //   scale: 1,
            // }
            startPointGeojson.properties.highlighted = false;
            startPointGeojsonFeatures.push(startPointGeojson);
            const centerCirclePolygon = [
                startPointGeojson.geometry.coordinates[0],
                startPointGeojson.geometry.coordinates[1]
            ];
            const radiusCirclePolygon = 40;
            const optionsCirclePolygon = {
                steps: 40,
                units: 'kilometers',
                properties: {
                    strokeColor: '#3A141F',
                    strokeOpacity: 0.8,
                    strokeWeight: 0.5,
                    fillColor: '#3A141F',
                    fillOpacity: 0.6
                }
            };
            const circlePolygon = (0, turf_1.circle)(centerCirclePolygon, radiusCirclePolygon, optionsCirclePolygon);
            let minLat = 200;
            let maxLat = -200;
            let minLong = 200;
            let maxLong = -200;
            for (let i = 0, countI = circlePolygon.geometry.coordinates[0].length; i < countI; i++) {
                if (minLat > circlePolygon.geometry.coordinates[0][i][1]) {
                    minLat = circlePolygon.geometry.coordinates[0][i][1];
                }
                if (maxLat < circlePolygon.geometry.coordinates[0][i][1]) {
                    maxLat = circlePolygon.geometry.coordinates[0][i][1];
                }
                if (minLong > circlePolygon.geometry.coordinates[0][i][0]) {
                    minLong = circlePolygon.geometry.coordinates[0][i][0];
                }
                if (maxLong < circlePolygon.geometry.coordinates[0][i][0]) {
                    maxLong = circlePolygon.geometry.coordinates[0][i][0];
                }
            }
            // minLat  = minLat * 1.1;
            // maxLat  = maxLat  * 1.1;
            // minLong = minLong * 1.1;
            // maxLong = maxLong * 1.1;
            circlePolygon.properties.minLat = minLat;
            circlePolygon.properties.maxLat = maxLat;
            circlePolygon.properties.minLong = minLong;
            circlePolygon.properties.maxLong = maxLong;
            const bbox1 = [-180, -90, 0, 90];
            const bbox2 = [0, -90, 180, 90];
            const optionsAllEarthBox = {
                properties: {
                    strokeColor: '#58D68D',
                    strokeOpacity: 0.001,
                    strokeWeight: 0.0001,
                    fillColor: '#58D68D',
                    fillOpacity: 0.2
                }
            };
            const allEarthBox1 = (0, turf_1.bboxPolygon)(bbox1, optionsAllEarthBox);
            const allEarthBox2 = (0, turf_1.bboxPolygon)(bbox2, optionsAllEarthBox);
            startPolygonsGeojsonFeatures.push(allEarthBox1);
            startPolygonsGeojsonFeatures.push(allEarthBox2);
            startPolygonsGeojsonFeatures.push(circlePolygon);
        }
        return {
            // points: {
            //   type: "FeatureCollection",
            //   features: startPointGeojsonFeatures
            // },
            polygons: {
                type: 'FeatureCollection',
                features: startPolygonsGeojsonFeatures
            }
        };
    }
};
